 function checkDeliveryPincode() {
    var val = document.getElementById('PincodeInput').value.trim();
    var msg = document.getElementById('PincodeMsg');
    if (val.length === 6 && /^\d+$/.test(val)) {
      msg.style.display = 'block';
      msg.style.color = '#155724';
      msg.style.backgroundColor = '#d4edda';
      msg.innerHTML = '✓ Estimated Delivery to ' + val + ': 3 - 5 Business Days';
    } else {
      msg.style.display = 'block';
      msg.style.color = '#721c24';
      msg.style.backgroundColor = '#f8d7da';
      msg.innerHTML = 'Please enter a valid 6-digit Pincode';
    }
  }